import "@event-calendar/core/index.css";
import React, { useEffect } from "react";
import { useLoaderData, useRevalidator } from "react-router";
import { Box } from "@mui/material";
import * as d from "shared/src/date.mjs";
import * as api from "../services/api";
import * as ws from "../utils/ws";
import {
  currentLocationFromRequest,
  useCurrentLocation,
} from "../components/LocationSelector";
import ResourceList from "../components/resource-list/ResourceList";
import { getAppointmentsByCalendarId } from "../components/resource-list/fn.mjs";
import { NowProvider } from "../components/now";
import { THROTTLE_REFRESH } from "../constants";
import { throttle } from "shared/src/util.mjs";

export async function loader({ request }) {
  const location_id = currentLocationFromRequest(request);

  const now = new Date();
  const from = d.toString(d.startOfDay(now));
  const to = d.toString(d.endOfDay(now));

  return api.loadReceptionSeatsData(
    {
      location_id,
      filter: {
        start: { gte: from, lt: to },
        location_id: { eq: location_id },
      },
      order: {
        asc: "start",
      },
      calendarFilter: {
        visible: { eq: true },
        location_id: { eq: location_id },
      },
    },
    api.contextFromRequest(request),
  );
}

/**
 * @param {object} msg
 * @param {string} location_id
 * @param {string} date
 *
 * @returns {boolean}
 */
function isInterestingNotification(msg, location_id, date) {
  switch (msg.type) {
    case "__connect":
      return true;
    case "appointment_changed": {
      const { location_ids, days } = msg.payload;

      if (Object.keys(msg.payload).length === 0) {
        return true;
      }

      return location_ids?.includes(location_id) && days.includes(date);
    }
  }

  return false;
}

export default function SeatsLive() {
  const loaderData = useLoaderData();
  const appointments = loaderData.data.appointments.data;
  const appointmentsByCalendarId = getAppointmentsByCalendarId(appointments);
  const resources = loaderData.data.calendars.data;
  const location_id = useCurrentLocation();

  const revalidator = useRevalidator();

  useEffect(() => {
    const refresh = throttle(() => {
      revalidator.revalidate();
    }, THROTTLE_REFRESH);

    function maybeRefresh(msg) {
      if (
        isInterestingNotification(msg, location_id, d.toDateString(new Date()))
      ) {
        refresh();
      }
    }

    ws.subscribe(maybeRefresh);

    return () => {
      ws.unsubscribe(maybeRefresh);
    };
  }, []);

  return (
    <Box sx={{ marginBottom: 2 }}>
      <NowProvider interval={1000}>
        <ResourceList
          resources={resources}
          appointmentsByCalendarId={appointmentsByCalendarId}
        />
      </NowProvider>
    </Box>
  );
}
